import {NumberUtil} from "base/format/utilities";
import {MaterialUtil} from "material/utils";

export function useTransportMaterialTable(displayFees) {
    const tableColumns = [
        {
            id: "species",
            label: "Espécie",
            width: 20,
        },
        {
            id: "quality",
            label: "Qualidade",
            width: 20,
        },
        {
            id: "type",
            label: "Tipo",
            width: 20,
        },
        {
            id: "length",
            label: "Comprimento das vigas",
            width: 15,
            textAlign: "right",
            formatFunction: item =>
                item.length ? `${NumberUtil.formatDecimal(item.length)} m` : null,
        },
        {
            id: "quantity",
            label: "Quantidade",
            width: 10,
            textAlign: "right",
            formatFunction: item => {
                const units = MaterialUtil.getUnitsForQuantity();
                if (item.quantity)
                    return `${NumberUtil.formatInteger(item.quantity)} ${units}`;
            },
        },

        displayFees
            ? {
                  id: "price",
                  label: "Valor de transporte",
                  textAlign: "right",
                  formatFunction: item => NumberUtil.formatCurrency(item.price),
              }
            : null,
    ].filter(column => column !== null);

    return {tableColumns};
}
